import gsap from 'gsap';

export class Magnetic {
  constructor(elem) {
    this.elem = elem;
    this.wrap = this.elem.closest('[data-magnetic-wrap]') || this.elem;

    this.options = {
      y: 0.8,
      x: 0.8,
      speed: 0.3,
      reverseSpeed: 0.5,
    }
    this.y = 0;
    this.x = 0;
    this.width = 0;
    this.height = 0;

    this.init();
  }

  init() {
    this.wrap.addEventListener('mouseenter', () => {
      const boundRect = this.elem.getBoundingClientRect();

      this.y = boundRect.top;
      this.x = boundRect.left;

      this.width = this.elem.clientWidth;
      this.height = this.elem.clientHeight;
    });

    this.wrap.addEventListener('mousemove', (e) => {
      const y = (e.clientY - this.y - this.height / 2) * this.options.y;
      const x = (e.clientX - this.x - this.width / 2) * this.options.x;

      this.move(x, y, this.options.speed);
    });

    this.wrap.addEventListener('mouseleave', () => {
      this.move(0, 0, this.options.reverseSpeed);
    });
  }

  move(x, y, speed) {
    gsap.to(this.elem, {
      y: y,
      x: x,
      overwrite: true,
      duration: speed,
    });
  }
}

export default class MagneticIterator {
  constructor() {
    this.magnetic = document.querySelectorAll('[data-magnetic]');

    if (this.magnetic.length) {
      this.magnetic.forEach(item => new Magnetic(item));
    }
  }
}